import { createReducer, on } from '@ngrx/store';
import { DeviceInformationApiActions } from './device-information.actions';
import { adapter, initialState } from './device-information.state';

export const deviceInformationFeatureKey = 'deviceInformation';

export const deviceInformationReducer = createReducer(
  initialState,
  on(DeviceInformationApiActions.deviceLoaded, (state, { deviceInformation }) =>
    adapter.upsertOne(deviceInformation, state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDeviceInformationIds = selectIds;

export const selectDeviceInformationEntities = selectEntities;

export const selectAllDeviceInformation = selectAll;
